import React from 'react';
import * as Inovx from '@shared';

var InovxControls = Inovx.Shared.Controls;

export interface ConfigurationFieldProps {
    title: string;
    inputName: string;
    className?: string;
    children: React.ReactNode;
}

const ConfigurationField: React.FC<ConfigurationFieldProps> = ({ title, inputName, className, children }) => {
    return (
        <InovxControls.FormField title={title} inputName={inputName} className={className}>
            {children}
        </InovxControls.FormField>
    );
};

export default ConfigurationField;